import React from 'react';

function BookmarkAddIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.5 20.25V5.3C5.5 4.8 5.675 4.375 6.025 4.025C6.375 3.675 6.8 3.5 7.3 3.5H13C13 3.78333 13 4.03333 13 4.25C13 4.46667 13 4.71667 13 5H7.3C7.23333 5 7.16667 5.03333 7.1 5.1C7.03333 5.16667 7 5.23333 7 5.3V17.95L12 15.8L17 17.95V11C17.2833 11 17.5333 11 17.75 11C17.9667 11 18.2167 11 18.5 11V20.25L12 17.45L5.5 20.25ZM7 5C7 5 7.03333 5 7.1 5C7.16667 5 7.23333 5 7.3 5H13H12H7ZM17 9V7H15V5.5H17V3.5H18.5V5.5H20.5V7H18.5V9H17Z"
        fill="#9B9BA0"
      />
    </svg>
  );
}

export default BookmarkAddIcon;
